import Util from './libs/util';

const util = new Util();

export default class effectManager {
    constructor(){
    }
    show($target, type) {
        switch (type) {
            case 'set':
                TweenMax.set($target, {
                    opacity: 0,
                    y:40,
                })

                break
            case 'show':
                TweenMax.staggerTo(
                    $target,
                    2.2,
                    {
                        opacity: 1,
                        y:0,
                        ease: Power2.easeOut,
                    },
                    0.05
                )

                break
            case 'out':
                TweenMax.killTweensOf($target, { opacity: true, x: true })
                TweenMax.staggerTo(
                    $target,
                    0.6,
                    {
                        opacity: 0,
                        y:50,
                    },
                    0.01
                )
                break
        }
    }
    fade($target, type) {
        switch (type) {
            case 'set':
                TweenMax.set($target, {
                    opacity: 0,
                })

                break
            case 'show':
                TweenMax.staggerTo(
                    $target,
                    0.6,
                    {
                        opacity: 1,
                        ease: Power2.easeOut,
                    },
                    0.05
                )

                break
            case 'out':
                TweenMax.killTweensOf($target, { opacity: true, x: true })
                TweenMax.staggerTo(
                    $target,
                    0.6,
                    {
                        opacity: 0,
                        y:50,
                    },
                    0.01
                )
                break
        }
    }
    split($target, type) {
        switch (type) {
            case 'set':
                let chars

                for (let n in $target) {
                    if ($target[n].nodeType != 1) continue // dom要素以外は処理止める

                    let text = new SplitText($target[n], {
                        type: 'words,chars',
                    })
                    chars = text.chars

                    for (let n in chars) {
                        TweenMax.set(chars[n], {
                            // opacity: 0,
                            y: '102%',
                            // filter: 'blur(10px)',
                        })
                    }
                }

                break
            case 'show':
                TweenMax.staggerTo(
                    $target,
                    1.6,
                    {
                        // opacity: 1,
                        y: '0%',
                        // filter: 'blur(0px)',
                        ease: Circ.easeOut,
                    },
                    0.05
                )

                break
            case 'out':
                TweenMax.killTweensOf($target, { opacity: true, x: true })
                TweenMax.staggerTo(
                    $target,
                    0.6,
                    {
                        opacity: 0,
                        x: -10,
                    },
                    0.01
                )
                break
        }
    }
    panel($target, type, dir) {
        switch (type) {
            case 'set':
                if(dir == 'y'){
                    TweenMax.set($target, {
                        y:-110+"%",
                    })
                }else{
                    TweenMax.set($target, {
                        x:-110+"%",
                    })
                }

                break
            case 'show':
                TweenMax.staggerTo(
                    $target,
                    0.6,
                    {
                        x: 0+"%",
                        y: 0+"%",
                        ease: Power2.easeOut,
                    },
                    0.05
                )

                break
            case 'out':
                TweenMax.killTweensOf($target, { opacity: true, x: true })
                TweenMax.staggerTo(
                    $target,
                    0.6,
                    {
                        opacity: 0,
                        y:50,
                    },
                    0.01
                )
                break
        }
    }
    scale($target, type) {
        switch (type) {
            case 'set':
                TweenMax.set($target, {
                    opacity:0,
                    scale:0.98,
                })

                break
            case 'show':
                TweenMax.staggerTo(
                    $target,
                    1.8,
                    {
                        opacity:1,
                        scale:1,
                        ease: Power2.easeOut,
                    },
                    0.05
                )

                break
            case 'out':
                TweenMax.killTweensOf($target, { opacity: true, x: true })
                TweenMax.staggerTo(
                    $target,
                    0.6,
                    {
                        opacity: 0,
                        y:50,
                    },
                    0.01
                )
                break
        }
    }
}
